<template>
  <div class="transport-container">
      <h3>Valgt transportform:</h3>
      <button
        class="transport-item bike"
        v-bind:class="{'selected': bikeMode}"
        @click="toggleBikeMode"
      >
        <Bike
          :iconColor="bikeMode ? '#FFFFFF' :'#9197BE'"
          :width="30"
        />
      </button>
      <button
        class="transport-item bus"
        v-bind:class="{'selected':transitMode}"
        @click="toggleTransitMode"
      >
        <Bus
          :iconColor="transitMode ? '#FFFFFF' :'#9197BE'"
          :width="30"
        />
      </button>
      <p
        class="tip"
        v-if="tripType===tripTypes.standard"
      ><i>Tip:</i> Klik på et busstoppested i kortet, hvis du vil cykle dertil.</p>
      <p
        class="via"
        v-else
      >Cykler til {{viaPlace.name}}.
        <button @click="removeCycleTo">
          <span class="fjern-x">
            <IconClose
              :color="'rgba(15,28,112,1)'"
              :width="12"
            />
          </span>
          Fortryd
        </button>
      </p>

      <label for="name">Walk reluctance (1-20):</label>

      <input
        @change="updateWalkReluctance"
        type="number"
        id="name"
        name="name"
        required
        min="1"
        max="20"
        :value="walkReluctance"
      >
  </div>
</template>

<script>
import Bike from '@/components/Icons/Bike';
import Bus from '@/components/Icons/Bus';
import { tripType } from '@/util/otp';
import IconClose from '@/components/Icons/Close.vue';
export default {
  name: 'transport-container',
  components: { Bike, Bus, IconClose },
  props: {
    modes: Object,
    toggleTransportMode: Function,
    viaPlace: Object,
    tripType: String,
    removeCycleTo: Function,
    walkReluctance: Number,
    setWalkReluctance: Function,
  },
  computed: {
    bikeMode() {
      return this.modes.bike;
    },
    transitMode() {
      return this.modes.transit;
    },
  },
  methods: {
    toggleBikeMode() {
      this.toggleTransportMode('bike');
    },
    toggleTransitMode() {
      this.toggleTransportMode('transit');
    },
    updateWalkReluctance(e) {
      const wr = parseInt(e.target.value);
      this.setWalkReluctance(wr);
    },
  },
  data: function() {
    return {
      tripTypes: tripType,
    };
  },
};
</script>

<style lang="scss" scoped>
input {
  width: 50px;
}
.transport-container {
  background: #ffffff;
  box-shadow: 0 0 15px 0 rgba(15, 28, 112, 0.1);
  border-radius: 6px;
  margin: 22px 60px 22px 80px;
  padding: 10px 18px 12px 40px;
  font-weight: 600;
}

label, input {display: none;}

h3 {
  color: #9197be;
  font-size: 16px;
  margin: 14px 0;
}

.transport-item {
  display: inline-block;
  margin-right: 18px;
  width: 70px;
  height: 42px;
  line-height: 47px;
  text-align: center;
  border-radius: 5px;
  cursor: pointer;
  border: 1px solid #c0c3d8;
  background: #fff;
}

.transport-item.selected {
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
}

.transport-item.bike.selected {
  background: #f94094;
  border: 1px solid #f94094;
}

.transport-item.bus.selected {
  background: #ff9901;
  border: 1px solid #ff9901;
}

p {
  color: #b8bcd5;
  font-size: 14px;
  margin-top: 20px;
  position: relative;
}
.tip {
  padding-left: 20px;
}
.tip:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 18px;
  height: 18px;
  background: url('../../assets/tip.svg') no-repeat center;
}
.via {
  margin-top: 18px;
  color: #9197be;
  button {
    background-color: #e2e4f4;
    font-weight: 600;
    border: none;
    border-radius: 10px;
    font-size: inherit;
    color: $primary-700;
    cursor: pointer;
    opacity: 0.4;
    padding: 5px 10px 3px 10px;
    line-height: 100%;
    span {
      display: inline-block;
      vertical-align: middle;
      margin-top: -2px;
    }
    &:hover {
      opacity: 0.7;
    }
  }
}

@media only screen and (max-width: $mobile-max-width ) {
  .transport-container {
    margin: 20px 30px 20px 60px;
    padding: 8px 10px 8px 25px;
  }

  h3 {
    font-size: 15px;
  }
}
</style>
